/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-unused-vars */
import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import GridViewIcon from "@mui/icons-material/GridView";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import "./Dasboard.css";
import { AiFillHome } from "react-icons/ai";
import { GrClose } from "react-icons/gr";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Routing from "../../Routing";
import { useEffect } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import { useState } from "react";
import { useMainContext } from "../../context/MainContext";
import NotificationModal from "../notifiaction/NotificationModal";

const drawerWidth = 240;

const formatDateTime = (dateTime) => {
  const date = new Date(dateTime);

  const dateOptions = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  const timeOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

  return `${formattedDate}, ${formattedTime}`;
};

export default function ResponsiveDrawer(props) {
  const {
    plansOpen,
    setPlansOpen,
    notifications,
    unreadCount,
    handleNotificationUpdate,
    notificationOpen,
    setNotificationOpen,
  } = useMainContext();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const hideClasses = location.pathname === "/login";
  const isPrintPage = location.pathname === "/user_details";
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [allOpen, setAllOpen] = React.useState(false);
  const [Open, setOpen] = React.useState(false);
  const [masterOpen, setMasterOpen] = React.useState(false);
  const [catOpen, setCatOpen] = React.useState(false);
  const [productOpen, setProductOpen] = React.useState(false);
  const [PagesOpen, setPagesOpen] = React.useState(false);
  const [slideOpen, setSlideOpen] = React.useState(false);
  const [faqOpen, setFaqOpen] = React.useState(false);
  const [portfolioOpen, setPortfolioOpen] = React.useState(false);
  const [DeliveryScheduleOpen, setDeliveryScheduleOpen] = React.useState(false);
  const [DeliveryBoyOpen, setDeliveryBoyOpen] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState("item1");
  const navigate = useNavigate("");
  const [currentDateTime, setCurrentDateTime] = React.useState(new Date());
  const [selectedImage1, setSelectedImage1] = useState(null);
  const [referralCode, setReferralCode] = useState("");
  const userDetails = sessionStorage.getItem("info");
  const useInfo = JSON.parse(userDetails);

  const formattedDateTime = formatDateTime(currentDateTime);

  const [day, rest] = formattedDateTime.split(", ", 1);
  const restDateTime = formattedDateTime.slice(day.length + 2);
  const [copy, setCopied] = useState(false);
  useEffect(() => {
    if (
      useInfo?.subscription_name === "" ||
      useInfo?.subscription_name === null
    ) {
      localStorage.setItem("planShow", "true");
    } else {
      localStorage.setItem("planShow", "false");
    }
  }, [useInfo]);

  const handleCopy = () => {
    if (referralCode) {
      // Check if clipboard API is available
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(referralCode)
          .then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
          })
          .catch((err) => {
            console.error("Failed to copy text:", err);
            fallbackCopy();
          });
      } else {
        // Fallback for unsupported mobile browsers
        fallbackCopy();
      }
    }
  };

  // Fallback function for copying text
  const fallbackCopy = () => {
    const textArea = document.createElement("textarea");
    textArea.value = referralCode;
    textArea.style.position = "fixed"; // Avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Fallback: Failed to copy text:", err);
    }

    document.body.removeChild(textArea);
  };

  // logo for admin
  useEffect(() => {
    const handleGetDetailsById = async () => {
      const user_id = useInfo?.id;
      try {
        const response = await axios.get(API_BASE_URL + `vendor/${user_id}`, {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        });
        if (response.data.status) {
          setReferralCode(response.data.data.seller_code);
          if (response.data.data.image) {
            setSelectedImage1(response.data.data.image);
          }
        }
      } catch (error) {
        console.log("error occured getting data", error);
      }
    };
    handleGetDetailsById();
  }, [useInfo?.id]);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("info") === null) {
      console.log("please login first");
      navigate("/login");
    }
  }, []);

  const handleCloseProfile = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("info");
    localStorage.removeItem("planShow");
    setAnchorEl(null);
    navigate("/login");
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCloseMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClick = (item) => {
    setActiveItem(item);
  };
  const drawer = (
    <div
      style={{
        paddingBottom: "5rem",
        backgroundColor: "black",
        display: isPrintPage ? "none" : "",
      }}
    >
      <style>
        {`
        /* Style the scrollbar */
        ::-webkit-scrollbar {
          width: 1px;
        }

        
      `}
      </style>
      <Toolbar
        className="ps-0 d-flex justify-content-between align-items-center"
        sx={{ height: "40px" }}
        style={{ backgroundColor: "black" }}
      >
        <Link className="admin-logo-sec" to="/">
          <img
            className="admin-logo"
            src={selectedImage1 !== null && selectedImage1}
            alt=""
          />
        </Link>
        <button className="close_menu_btn" onClick={handleCloseMenu}>
          <GrClose color="#625C5C" />
        </button>
      </Toolbar>
      <Divider></Divider>
      <List>
        <Link to="/" className="link_tag">
          <ListItem
            className={location.pathname === "/" ? "active" : "bg_dashboard"}
            onClick={() => handleClick("item1")}
            disablePadding
          >
            {" "}
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                {/* <GridViewIcon /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333ZM7.5 15.8333H4.16667V12.5H7.5V15.8333ZM16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5ZM15.8333 7.5H12.5V4.16667H15.8333V7.5ZM16.6667 13.3333H15V11.6667C15 11.4457 14.9122 11.2337 14.7559 11.0774C14.5996 10.9211 14.3877 10.8333 14.1667 10.8333C13.9457 10.8333 13.7337 10.9211 13.5774 11.0774C13.4211 11.2337 13.3333 11.4457 13.3333 11.6667V13.3333H11.6667C11.4457 13.3333 11.2337 13.4211 11.0774 13.5774C10.9211 13.7337 10.8333 13.9457 10.8333 14.1667C10.8333 14.3877 10.9211 14.5996 11.0774 14.7559C11.2337 14.9122 11.4457 15 11.6667 15H13.3333V16.6667C13.3333 16.8877 13.4211 17.0996 13.5774 17.2559C13.7337 17.4122 13.9457 17.5 14.1667 17.5C14.3877 17.5 14.5996 17.4122 14.7559 17.2559C14.9122 17.0996 15 16.8877 15 16.6667V15H16.6667C16.8877 15 17.0996 14.9122 17.2559 14.7559C17.4122 14.5996 17.5 14.3877 17.5 14.1667C17.5 13.9457 17.4122 13.7337 17.2559 13.5774C17.0996 13.4211 16.8877 13.3333 16.6667 13.3333ZM8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5ZM7.5 7.5H4.16667V4.16667H7.5V7.5Z"
                    fill={location.pathname === "/" ? "#F99F21" : "white"}
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Dashboard</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>

        {/* <Link to="/orders" className="link_tag">
          <ListItem
            className={
              location.pathname === "/orders" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item9_00")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6667 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5ZM9.16667 15.8333H4.16667V10.8333H9.16667V15.8333ZM9.16667 9.16667H4.16667V4.16667H9.16667V9.16667ZM15.8333 15.8333H10.8333V10.8333H15.8333V15.8333ZM15.8333 9.16667H10.8333V4.16667H15.8333V9.16667Z"
                    fill={location.pathname === "/orders" ? "#F99F21" : "white"}
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Orders</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}

        <Link to="/seller_products" className="link_tag">
          <ListItem
            className={
              location.pathname === "/seller_products"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* <img
                  src={require("../assets/images/tables-icon/products.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8333 5.83329H13.3333V4.99996C13.3333 4.1159 12.9822 3.26806 12.357 2.64294C11.7319 2.01782 10.8841 1.66663 10 1.66663C9.11595 1.66663 8.26811 2.01782 7.64299 2.64294C7.01787 3.26806 6.66668 4.1159 6.66668 4.99996V5.83329H4.16668C3.94566 5.83329 3.7337 5.92109 3.57742 6.07737C3.42114 6.23365 3.33334 6.44561 3.33334 6.66663V15.8333C3.33334 16.4963 3.59674 17.1322 4.06558 17.6011C4.53442 18.0699 5.1703 18.3333 5.83334 18.3333H14.1667C14.8297 18.3333 15.4656 18.0699 15.9344 17.6011C16.4033 17.1322 16.6667 16.4963 16.6667 15.8333V6.66663C16.6667 6.44561 16.5789 6.23365 16.4226 6.07737C16.2663 5.92109 16.0544 5.83329 15.8333 5.83329ZM8.33334 4.99996C8.33334 4.55793 8.50894 4.13401 8.8215 3.82145C9.13406 3.50889 9.55798 3.33329 10 3.33329C10.442 3.33329 10.866 3.50889 11.1785 3.82145C11.4911 4.13401 11.6667 4.55793 11.6667 4.99996V5.83329H8.33334V4.99996ZM15 15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4225C14.5997 16.5788 14.3877 16.6666 14.1667 16.6666H5.83334C5.61233 16.6666 5.40037 16.5788 5.24409 16.4225C5.08781 16.2663 5.00001 16.0543 5.00001 15.8333V7.49996H6.66668V8.33329C6.66668 8.55431 6.75447 8.76627 6.91075 8.92255C7.06703 9.07883 7.279 9.16663 7.50001 9.16663C7.72102 9.16663 7.93299 9.07883 8.08927 8.92255C8.24555 8.76627 8.33334 8.55431 8.33334 8.33329V7.49996H11.6667V8.33329C11.6667 8.55431 11.7545 8.76627 11.9108 8.92255C12.067 9.07883 12.279 9.16663 12.5 9.16663C12.721 9.16663 12.933 9.07883 13.0893 8.92255C13.2455 8.76627 13.3333 8.55431 13.3333 8.33329V7.49996H15V15.8333Z"
                    fill={
                      location.pathname === "/seller_products"
                        ? "#F99F21"
                        : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">
                Products Catalogue
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/leads" className="link_tag">
          <ListItem
            className={
              location.pathname === "/leads" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* <img
                  src={require("../assets/images/tables-icon/products.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                    fill={location.pathname === "/leads" ? "#F99F21" : "white"}
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Buyer Order</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        {!plansOpen ? (
          <Link to="/plans/history" className="link_tag">
            <ListItem
              className={
                location.pathname === "/plans/history"
                  ? "active"
                  : "bg_dashboard"
              }
              disablePadding
              onClick={() => handleClick("item2")}
            >
              <ListItemButton>
                <ListItemIcon>
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 1.66667C5.3975 1.66667 1.66667 5.3975 1.66667 10C1.66667 14.6025 5.3975 18.3333 10 18.3333C14.6025 18.3333 18.3333 14.6025 18.3333 10C18.3333 5.3975 14.6025 1.66667 10 1.66667ZM10 16.6667C6.31875 16.6667 3.33333 13.6813 3.33333 10C3.33333 6.31875 6.31875 3.33333 10 3.33333C13.6813 3.33333 16.6667 6.31875 16.6667 10C16.6667 13.6813 13.6813 16.6667 10 16.6667ZM10 9.16667C9.27167 9.16667 8.66667 9.77167 8.66667 10.5C8.66667 11.2283 9.27167 11.8333 10 11.8333C10.7283 11.8333 11.3333 11.2283 11.3333 10.5C11.3333 9.77167 10.7283 9.16667 10 9.16667ZM10 5.83333C9.08333 5.83333 8.33333 6.58333 8.33333 7.5C8.33333 8.41667 9.08333 9.16667 10 9.16667C10.9167 9.16667 11.6667 8.41667 11.6667 7.5C11.6667 6.58333 10.9167 5.83333 10 5.83333Z"
                      fill={
                        location.pathname === "/plans/history"
                          ? "#F99F21"
                          : "white"
                      }
                    />
                  </svg>
                </ListItemIcon>
                <ListItemText className="custom-font">
                  My Subscription <br /> (Go Online)
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </Link>
        ) : (
          <Link to="/plans" className="link_tag">
            <ListItem
              className={
                location.pathname === "/plans" ? "active" : "bg_dashboard"
              }
              disablePadding
              onClick={() => {
                handleClick("item2");
                useInfo?.subscription_name === "" ||
                useInfo?.subscription_name === null
                  ? setPlansOpen(true)
                  : setPlansOpen(false);
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 1.66667C5.3975 1.66667 1.66667 5.3975 1.66667 10C1.66667 14.6025 5.3975 18.3333 10 18.3333C14.6025 18.3333 18.3333 14.6025 18.3333 10C18.3333 5.3975 14.6025 1.66667 10 1.66667ZM10 16.6667C6.31875 16.6667 3.33333 13.6813 3.33333 10C3.33333 6.31875 6.31875 3.33333 10 3.33333C13.6813 3.33333 16.6667 6.31875 16.6667 10C16.6667 13.6813 13.6813 16.6667 10 16.6667ZM10 9.16667C9.27167 9.16667 8.66667 9.77167 8.66667 10.5C8.66667 11.2283 9.27167 11.8333 10 11.8333C10.7283 11.8333 11.3333 11.2283 11.3333 10.5C11.3333 9.77167 10.7283 9.16667 10 9.16667ZM10 5.83333C9.08333 5.83333 8.33333 6.58333 8.33333 7.5C8.33333 8.41667 9.08333 9.16667 10 9.16667C10.9167 9.16667 11.6667 8.41667 11.6667 7.5C11.6667 6.58333 10.9167 5.83333 10 5.83333Z"
                      fill={
                        location.pathname === "/plans" ? "#F99F21" : "white"
                      }
                    />
                  </svg>
                </ListItemIcon>
                <ListItemText className="custom-font">
                  My Subscription (Go Online)
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </Link>
        )}
        <Link to="/seller/storeImages" className="link_tag">
          <ListItem
            className={
              location.pathname === "/seller/storeImages"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* <img
                  src={require("../assets/images/tables-icon/products.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 8H3L1 12V20C1 20.55 1.45 21 2 21H10C10.55 21 11 20.55 11 20V16C11 15.45 11.45 15 12 15C12.55 15 13 15.45 13 16V20C13 20.55 13.45 21 14 21H22C22.55 21 23 20.55 23 20V12L21 8ZM3 8V6C3 4.9 3.9 4 5 4H19C20.1 4 21 4.9 21 6V8H3Z"
                    fill={
                      location.pathname === "/seller/storeImages"
                        ? "#F99F21"
                        : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Store Images</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        {/* <Link to="/wallet/withdrawal" className="link_tag">
          <ListItem
            className={
              location.pathname === "/wallet/withdrawal"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 6.5H19V6a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v.5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2zM7 6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v.5H7V6zm8.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                    fill={
                      location.pathname === "/wallet/withdrawal"
                        ? "#F99F21"
                        : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Pure X Wallet</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
        <Link to="/edit_profile" className="link_tag">
          <ListItem
            className={
              location.pathname === "/edit_profile" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* <img
                  src={require("../assets/images/tables-icon/products.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.33 0-10 1.67-10 5v2h20v-2c0-3.33-6.67-5-10-5z"
                    fill={
                      location.pathname === "/edit_profile"
                        ? "#F99F21"
                        : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Profile</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        {/* <Link
          to="https://puredesistores.com/"
          className="link_tag"
          target="_blank"
        >
          <Link
            to="https://puredesistores.com/"
            className="link_tag"
            target="_blank"
          >
            <ListItem
              className={
                location.pathname === "https://puredesistores.com/"
                  ? "active"
                  : "bg_dashboard"
              }
              disablePadding
              onClick={() => handleClick("item11")}
            >
              <ListItemButton>
                <ListItemIcon className="icon_bg">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.8333 5.83329H13.3333V4.99996C13.3333 4.1159 12.9822 3.26806 12.357 2.64294C11.7319 2.01782 10.8841 1.66663 10 1.66663C9.11595 1.66663 8.26811 2.01782 7.64299 2.64294C7.01787 3.26806 6.66668 4.1159 6.66668 4.99996V5.83329H4.16668C3.94566 5.83329 3.7337 5.92109 3.57742 6.07737C3.42114 6.23365 3.33334 6.44561 3.33334 6.66663V15.8333C3.33334 16.4963 3.59674 17.1322 4.06558 17.6011C4.53442 18.0699 5.1703 18.3333 5.83334 18.3333H14.1667C14.8297 18.3333 15.4656 18.0699 15.9344 17.6011C16.4033 17.1322 16.6667 16.4963 16.6667 15.8333V6.66663C16.6667 6.44561 16.5789 6.23365 16.4226 6.07737C16.2663 5.92109 16.0544 5.83329 15.8333 5.83329ZM8.33334 4.99996C8.33334 4.55793 8.50894 4.13401 8.8215 3.82145C9.13406 3.50889 9.55798 3.33329 10 3.33329C10.442 3.33329 10.866 3.50889 11.1785 3.82145C11.4911 4.13401 11.6667 4.55793 11.6667 4.99996V5.83329H8.33334V4.99996ZM15 15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4225C14.5997 16.5788 14.3877 16.6666 14.1667 16.6666H5.83334C5.61233 16.6666 5.40037 16.5788 5.24409 16.4225C5.08781 16.2663 5.00001 16.0543 5.00001 15.8333V7.49996H6.66668V8.33329C6.66668 8.55431 6.75447 8.76627 6.91075 8.92255C7.06703 9.07883 7.279 9.16663 7.50001 9.16663C7.72102 9.16663 7.93299 9.07883 8.08927 8.92255C8.24555 8.76627 8.33334 8.55431 8.33334 8.33329V7.49996H11.6667V8.33329C11.6667 8.55431 11.7545 8.76627 11.9108 8.92255C12.067 9.07883 12.279 9.16663 12.5 9.16663C12.721 9.16663 12.933 9.07883 13.0893 8.92255C13.2455 8.76627 13.3333 8.55431 13.3333 8.33329V7.49996H15V15.8333Z"
                      fill={
                        location.pathname === "https://puredesistores.com/"
                          ? "#F99F21"
                          : "white"
                      }
                    />
                  </svg>
                </ListItemIcon>
                <ListItemText className="custom-font">
                  Buy product with WedMeGood
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </Link>
        </Link> */}
        {/* <Link to="/products/unverified" className="link_tag">
          <Link to="/products/unverified" className="link_tag">
            <ListItem
              className={
                location.pathname === "/products/unverified"
                  ? "active"
                  : "bg_dashboard"
              }
              disablePadding
              onClick={() => handleClick("item11")}
            >
              <ListItemButton>
                <ListItemIcon className="icon_bg">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.8333 5.83329H13.3333V4.99996C13.3333 4.1159 12.9822 3.26806 12.357 2.64294C11.7319 2.01782 10.8841 1.66663 10 1.66663C9.11595 1.66663 8.26811 2.01782 7.64299 2.64294C7.01787 3.26806 6.66668 4.1159 6.66668 4.99996V5.83329H4.16668C3.94566 5.83329 3.7337 5.92109 3.57742 6.07737C3.42114 6.23365 3.33334 6.44561 3.33334 6.66663V15.8333C3.33334 16.4963 3.59674 17.1322 4.06558 17.6011C4.53442 18.0699 5.1703 18.3333 5.83334 18.3333H14.1667C14.8297 18.3333 15.4656 18.0699 15.9344 17.6011C16.4033 17.1322 16.6667 16.4963 16.6667 15.8333V6.66663C16.6667 6.44561 16.5789 6.23365 16.4226 6.07737C16.2663 5.92109 16.0544 5.83329 15.8333 5.83329ZM8.33334 4.99996C8.33334 4.55793 8.50894 4.13401 8.8215 3.82145C9.13406 3.50889 9.55798 3.33329 10 3.33329C10.442 3.33329 10.866 3.50889 11.1785 3.82145C11.4911 4.13401 11.6667 4.55793 11.6667 4.99996V5.83329H8.33334V4.99996ZM15 15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4225C14.5997 16.5788 14.3877 16.6666 14.1667 16.6666H5.83334C5.61233 16.6666 5.40037 16.5788 5.24409 16.4225C5.08781 16.2663 5.00001 16.0543 5.00001 15.8333V7.49996H6.66668V8.33329C6.66668 8.55431 6.75447 8.76627 6.91075 8.92255C7.06703 9.07883 7.279 9.16663 7.50001 9.16663C7.72102 9.16663 7.93299 9.07883 8.08927 8.92255C8.24555 8.76627 8.33334 8.55431 8.33334 8.33329V7.49996H11.6667V8.33329C11.6667 8.55431 11.7545 8.76627 11.9108 8.92255C12.067 9.07883 12.279 9.16663 12.5 9.16663C12.721 9.16663 12.933 9.07883 13.0893 8.92255C13.2455 8.76627 13.3333 8.55431 13.3333 8.33329V7.49996H15V15.8333Z"
                      fill={
                        location.pathname === "/products/unverified"
                          ? "#F99F21"
                          : "white"
                      }
                    />
                  </svg>
                </ListItemIcon>
                <ListItemText className="custom-font">
                  Un-Verified Products
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </Link>
        </Link> */}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      {!isLoginPage && (
        <>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
            }}
          >
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: "space-between",
                height: "40px",
                backgroundColor: "#FFFFFF",
                hideClasses,
              }}
            >
              <div className="d-flex align-items-center drawer-btn-box">
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                  className="drawer-btn"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                  <div className="me-2 admin_title_header">
                    <div>
                      <h5 className="header_heading">
                        welcome back,{" "}
                        <span className="text-success">
                          (Seller Code:{referralCode} (use for receive payment))
                        </span>{" "}
                        <button onClick={handleCopy} className="btnCopy">
                          {copy ? "Copied" : "Copy"}
                        </button>
                      </h5>
                      <p className="time_header_para">
                        <span style={{ color: "black" }}>{day}</span>,{" "}
                        {restDateTime}
                      </p>
                    </div>
                  </div>{" "}
                </Typography>
              </div>
              {/* <div style={{ display: "flex", alignItems: "center" }}>
                <div className="search_div_header">
                  <div>
                    <input
                      type="text"
                      className="form-control search_header_input"
                      placeholder="Search for Anything..."
                    />
                  </div>
                  <div className="search_icon_input">
                    <svg
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.2825 14.2175L12.5 11.4575C13.5801 10.1108 14.1031 8.40147 13.9616 6.68097C13.8201 4.96047 13.0247 3.35958 11.7391 2.20748C10.4535 1.05538 8.77534 0.43963 7.04968 0.48685C5.32402 0.53407 3.68203 1.24067 2.46135 2.46135C1.24066 3.68204 0.534062 5.32403 0.486842 7.04969C0.439622 8.77535 1.05537 10.4535 2.20747 11.7391C3.35958 13.0247 4.96047 13.8201 6.68096 13.9616C8.40146 14.1031 10.1108 13.5801 11.4575 12.5L14.2175 15.26C14.2872 15.3303 14.3702 15.3861 14.4616 15.4242C14.5529 15.4622 14.651 15.4818 14.75 15.4818C14.849 15.4818 14.947 15.4622 15.0384 15.4242C15.1298 15.3861 15.2128 15.3303 15.2825 15.26C15.4177 15.1201 15.4932 14.9333 15.4932 14.7387C15.4932 14.5442 15.4177 14.3573 15.2825 14.2175ZM7.24999 12.5C6.21164 12.5 5.1966 12.1921 4.33325 11.6152C3.46989 11.0383 2.79698 10.2184 2.39962 9.25909C2.00226 8.29977 1.89829 7.24417 2.10087 6.22577C2.30344 5.20737 2.80345 4.27191 3.53768 3.53769C4.2719 2.80346 5.20737 2.30345 6.22577 2.10087C7.24416 1.8983 8.29977 2.00227 9.25908 2.39963C10.2184 2.79699 11.0383 3.4699 11.6152 4.33325C12.1921 5.19661 12.5 6.21165 12.5 7.25C12.5 8.64238 11.9469 9.97774 10.9623 10.9623C9.97773 11.9469 8.64237 12.5 7.24999 12.5Z"
                        fill="#818181"
                      />
                    </svg>
                  </div>
                  <div className="search_filter_icon">
                    <svg
                      width={40}
                      height={40}
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width={40} height={40} rx={20} fill="black" />
                      <path
                        d="M22.865 26L26.75 26C26.9489 26 27.1397 25.921 27.2803 25.7803C27.421 25.6397 27.5 25.4489 27.5 25.25C27.5 25.0511 27.421 24.8603 27.2803 24.7197C27.1397 24.579 26.9489 24.5 26.75 24.5L22.865 24.5C22.7073 24.0656 22.4198 23.6903 22.0414 23.4251C21.663 23.1599 21.2121 23.0176 20.75 23.0176C20.2879 23.0176 19.837 23.1599 19.4586 23.4251C19.0802 23.6903 18.7927 24.0656 18.635 24.5L13.25 24.5C13.0511 24.5 12.8603 24.579 12.7197 24.7197C12.579 24.8603 12.5 25.0511 12.5 25.25C12.5 25.4489 12.579 25.6397 12.7197 25.7803C12.8603 25.921 13.0511 26 13.25 26L18.635 26C18.7927 26.4344 19.0802 26.8097 19.4586 27.0749C19.837 27.3401 20.2879 27.4824 20.75 27.4824C21.2121 27.4824 21.663 27.3401 22.0414 27.0749C22.4198 26.8097 22.7073 26.4344 22.865 26ZM20 25.25C20 25.1017 20.044 24.9567 20.1264 24.8333C20.2088 24.71 20.3259 24.6139 20.463 24.5571C20.6 24.5003 20.7508 24.4855 20.8963 24.5144C21.0418 24.5433 21.1754 24.6148 21.2803 24.7197C21.3852 24.8246 21.4567 24.9582 21.4856 25.1037C21.5145 25.2492 21.4997 25.4 21.4429 25.537C21.3861 25.6741 21.29 25.7912 21.1667 25.8736C21.0433 25.956 20.8983 26 20.75 26C20.5511 26 20.3603 25.921 20.2197 25.7803C20.079 25.6397 20 25.4489 20 25.25ZM18.365 20.75L26.75 20.75C26.9489 20.75 27.1397 20.671 27.2803 20.5303C27.421 20.3897 27.5 20.1989 27.5 20C27.5 19.8011 27.421 19.6103 27.2803 19.4697C27.1397 19.329 26.9489 19.25 26.75 19.25L18.365 19.25C18.2073 18.8156 17.9198 18.4403 17.5414 18.1751C17.163 17.9099 16.7121 17.7676 16.25 17.7676C15.7879 17.7676 15.337 17.9099 14.9586 18.1751C14.5802 18.4403 14.2927 18.8156 14.135 19.25L13.25 19.25C13.0511 19.25 12.8603 19.329 12.7197 19.4697C12.579 19.6103 12.5 19.8011 12.5 20C12.5 20.1989 12.579 20.3897 12.7197 20.5303C12.8603 20.671 13.0511 20.75 13.25 20.75L14.135 20.75C14.2927 21.1844 14.5802 21.5597 14.9586 21.8249C15.337 22.0901 15.7879 22.2324 16.25 22.2324C16.7121 22.2324 17.163 22.0901 17.5414 21.8249C17.9198 21.5597 18.2073 21.1844 18.365 20.75ZM15.5 20C15.5 19.8517 15.544 19.7067 15.6264 19.5833C15.7088 19.46 15.8259 19.3639 15.963 19.3071C16.1 19.2503 16.2508 19.2355 16.3963 19.2644C16.5418 19.2933 16.6754 19.3648 16.7803 19.4697C16.8852 19.5746 16.9567 19.7082 16.9856 19.8537C17.0145 19.9992 16.9997 20.15 16.9429 20.287C16.8861 20.4241 16.79 20.5412 16.6667 20.6236C16.5433 20.706 16.3983 20.75 16.25 20.75C16.0511 20.75 15.8603 20.671 15.7197 20.5303C15.579 20.3897 15.5 20.1989 15.5 20ZM24.365 15.5L26.75 15.5C26.9489 15.5 27.1397 15.421 27.2803 15.2803C27.421 15.1397 27.5 14.9489 27.5 14.75C27.5 14.5511 27.421 14.3603 27.2803 14.2197C27.1397 14.079 26.9489 14 26.75 14L24.365 14C24.2073 13.5656 23.9198 13.1903 23.5414 12.9251C23.163 12.6599 22.7121 12.5176 22.25 12.5176C21.7879 12.5176 21.337 12.6599 20.9586 12.9251C20.5802 13.1903 20.2927 13.5656 20.135 14L13.25 14C13.0511 14 12.8603 14.079 12.7197 14.2197C12.579 14.3603 12.5 14.5511 12.5 14.75C12.5 14.9489 12.579 15.1397 12.7197 15.2803C12.8603 15.421 13.0511 15.5 13.25 15.5L20.135 15.5C20.2927 15.9344 20.5802 16.3097 20.9586 16.5749C21.337 16.8401 21.7879 16.9824 22.25 16.9824C22.7121 16.9824 23.163 16.8401 23.5414 16.5749C23.9198 16.3097 24.2073 15.9344 24.365 15.5ZM21.5 14.75C21.5 14.6017 21.544 14.4567 21.6264 14.3333C21.7088 14.21 21.8259 14.1139 21.963 14.0571C22.1 14.0003 22.2508 13.9855 22.3963 14.0144C22.5418 14.0433 22.6754 14.1148 22.7803 14.2197C22.8852 14.3246 22.9567 14.4582 22.9856 14.6037C23.0145 14.7492 22.9997 14.9 22.9429 15.037C22.8861 15.1741 22.79 15.2912 22.6667 15.3736C22.5433 15.456 22.3983 15.5 22.25 15.5C22.0511 15.5 21.8603 15.421 21.7197 15.2803C21.579 15.1397 21.5 14.9489 21.5 14.75Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div> */}

              <div style={{ display: "flex", alignItems: "center" }}>
                {/* mail and notification */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    position: "relative",
                    marginRight: "10px",
                  }}
                >
                  <div
                    onClick={() => {
                      setNotificationOpen(true);
                      notifications.length > 0 && handleNotificationUpdate();
                    }}
                    className="notification-box"
                  >
                    <svg
                      width={25}
                      height={25}
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.3957 13.6249V13.5189V10.2573C18.3943 8.83937 17.8911 7.46774 16.9753 6.38528C16.0596 5.30282 14.7902 4.57937 13.3922 4.34306L13.2672 4.32193V4.19516V3.07713C13.2672 2.84488 13.1749 2.62214 13.0107 2.45791C12.8465 2.29368 12.6237 2.20142 12.3915 2.20142C12.1592 2.20142 11.9365 2.29368 11.7723 2.45791C11.608 2.62214 11.5158 2.84488 11.5158 3.07713V4.19516V4.32193L11.3908 4.34306C9.99271 4.57937 8.72339 5.30282 7.80761 6.38528C6.89185 7.46771 6.38868 8.83927 6.38721 10.2571C6.38721 10.2572 6.38721 10.2572 6.38721 10.2573M18.3957 13.6249L6.23721 10.2571L6.38721 10.2573M18.3957 13.6249L18.4957 13.6603C19.0651 13.8616 19.5583 14.2341 19.9076 14.7267C20.257 15.2193 20.4455 15.8079 20.4472 16.4118V18.4628C20.4472 18.695 20.3549 18.9178 20.1907 19.082C20.0264 19.2462 19.8037 19.3385 19.5714 19.3385H16.3507H16.236L16.206 19.4492C15.9784 20.2865 15.4816 21.0258 14.7922 21.5528C14.1029 22.0798 13.2592 22.3654 12.3915 22.3654C11.5237 22.3654 10.6801 22.0798 9.99071 21.5528C9.30134 21.0258 8.80455 20.2865 8.57698 19.4492L8.54691 19.3385H8.43223H5.2115C4.97925 19.3385 4.75651 19.2462 4.59228 19.082C4.42805 18.9178 4.33579 18.695 4.33579 18.4628V16.4116C4.33753 15.8077 4.52598 15.2192 4.8753 14.7267C5.22466 14.2341 5.71784 13.8616 6.28721 13.6603L6.38721 13.6249V13.5189L6.38721 10.2573M18.3957 13.6249L6.38721 10.2573M16.4943 13.4842H16.6443V13.3342V10.2571C16.6443 9.12918 16.1962 8.04745 15.3987 7.24989C14.6011 6.45233 13.5194 6.00426 12.3915 6.00426C11.2635 6.00426 10.1818 6.45233 9.38426 7.24989C8.5867 8.04745 8.13863 9.12918 8.13863 10.2571V13.3342V13.4842H8.28863H16.4943ZM10.6273 19.3385H10.3674L10.4973 19.5635C10.6894 19.8962 10.9652 20.1729 11.2974 20.366C11.6295 20.5591 12.0064 20.6619 12.3906 20.6642L12.3924 20.6642C12.7766 20.6619 13.1534 20.5591 13.4856 20.366C13.8177 20.1729 14.0935 19.8962 14.2856 19.5635L14.4155 19.3385H14.1557H10.6273ZM18.5457 17.5871H18.6957V17.4371V16.4114C18.6957 16.0995 18.5719 15.8005 18.3514 15.58C18.1309 15.3595 17.8318 15.2357 17.52 15.2357H7.26292C6.9511 15.2357 6.65206 15.3595 6.43157 15.58C6.21108 15.8005 6.08721 16.0995 6.08721 16.4114V17.4371V17.5871H6.23721H18.5457Z"
                        fill="#818181"
                        stroke="white"
                        strokeWidth="0.3"
                      />
                      <circle
                        cx="2.4617"
                        cy="2.4617"
                        r="2.4617"
                        transform="matrix(1 0 0 -1 17.3149 6.56454)"
                        fill="#FF0000"
                      />
                    </svg>
                    {unreadCount > 0 && <span>{unreadCount}</span>}
                  </div>
                </div>
                <div>
                  {/* Profile Dropdown */}
                  <IconButton
                    onClick={handleProfileClick}
                    aria-controls="profile-menu"
                    aria-haspopup="true"
                    color="inherit"
                  >
                    {/* <MoreVertIcon /> */}
                    <svg
                      width={35}
                      height={35}
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="17.375"
                        cy="17.375"
                        r="17.375"
                        fill="#F4F4F4"
                      />
                      <mask
                        id="mask0_47_31"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x={8}
                        y={8}
                        width={19}
                        height={19}
                      >
                        <rect
                          x="8.6875"
                          y="8.6875"
                          width="17.375"
                          height="17.375"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_47_31)">
                        <path
                          d="M17.375 17.375C16.5786 17.375 15.8969 17.0915 15.3298 16.5244C14.7627 15.9573 14.4791 15.2755 14.4791 14.4792C14.4791 13.6828 14.7627 13.0011 15.3298 12.434C15.8969 11.8669 16.5786 11.5833 17.375 11.5833C18.1713 11.5833 18.8531 11.8669 19.4202 12.434C19.9873 13.0011 20.2708 13.6828 20.2708 14.4792C20.2708 15.2755 19.9873 15.9573 19.4202 16.5244C18.8531 17.0915 18.1713 17.375 17.375 17.375ZM11.5833 23.1667V21.1396C11.5833 20.7293 11.6889 20.3523 11.9 20.0084C12.1112 19.6645 12.3917 19.4021 12.7416 19.2211C13.4897 18.8471 14.2499 18.5665 15.0221 18.3795C15.7943 18.1925 16.5786 18.099 17.375 18.099C18.1713 18.099 18.9556 18.1925 19.7278 18.3795C20.5001 18.5665 21.2602 18.8471 22.0083 19.2211C22.3582 19.4021 22.6388 19.6645 22.8499 20.0084C23.0611 20.3523 23.1666 20.7293 23.1666 21.1396V23.1667H11.5833Z"
                          fill="#808080"
                        />
                      </g>
                    </svg>
                  </IconButton>
                  <Menu
                    id="profile-menu"
                    className=""
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseProfile}
                  >
                    <Link
                      to="/edit_profile"
                      className="text-decoration-none text-dark"
                    >
                      {" "}
                      <MenuItem onClick={handleCloseProfile}>
                        Edit Profile{" "}
                      </MenuItem>
                    </Link>
                    <Link
                      to="/change_password"
                      className="text-decoration-none text-dark"
                    >
                      {" "}
                      <MenuItem onClick={handleCloseProfile}>
                        Change Password
                      </MenuItem>
                    </Link>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                  </Menu>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "black",
                },
              }}
            >
              {!isLoginPage && <>{drawer}</>}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "black",
                },
              }}
              open
            >
              {!isLoginPage && <>{drawer}</>}
            </Drawer>
          </Box>
        </>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {!isLoginPage && (
          <>
            <Toolbar />
          </>
        )}
        <Routing />
        {notificationOpen && (
          <NotificationModal
            notificationOpen={notificationOpen}
            setNotificationOpen={setNotificationOpen}
          />
        )}
      </Box>
    </Box>
  );
}
